import { createContext, useContext } from 'react'
import { Shadow } from '../types/Shadow.types'
import { FieldErrors } from '../services/machines/configuration'

export const ConfigurationFormContext = createContext<{
    errors: FieldErrors
    unavailable: Partial<Record<Shadow, string>>
    fieldReadErrors: FieldErrors
    saving: boolean
}>({ errors: {}, unavailable: {}, fieldReadErrors: {}, saving: false })

export function useConfigurationField(name: string) {
    const { errors, unavailable, fieldReadErrors, saving } = useContext(ConfigurationFormContext)
    const shadow = name.split('.')[0] as Shadow
    return {
        error: errors[name],
        // A field of an unreadable section has no known value; never render the editor's default in its place.
        readError: unavailable[shadow] ? 'Nie udało się odczytać tej wartości z urządzenia.' : fieldReadErrors[name],
        disabled: saving,
    }
}
